module.exports = __webpack_public_path__ + "img/hld_h.f5c3b6e0.svg";